export default {
	id: "",
	type: "",
	animationTrigger: "show",
};
